import type { ComparisonTableFeature, ComparisonTableGroup, ComparisonTablePlan } from '@ctct/payflow-ui';

export type InitialPlan = Omit<ComparisonTablePlan, 'price'>;

// SMS Marketing group ID used across all content strategies
export const SMS_MARKETING_GROUP_ID = 'smsMarketing';

// Placeholders used by content strategies in place of literal SMS pricing/copy.
// PlanComparisonTableService resolves these to country-config-derived, translated
// strings when building the SMS Marketing group content, so content stays "dumb".
export const SMS_STARTING_PRICE_TOKEN = '{{SMS_STARTING_PRICE}}';

export const SMS_INCLUDED_FREE_TOKEN = '{{SMS_INCLUDED_FREE}}';

export const INBOX_PREVIEW_PRICE_TOKEN = '{{INBOX_PREVIEW_PRICE}}';

export interface ContentStrategy {
  getStaticTableContent(): ComparisonTableFeature[];
  getInitialGroups(): ComparisonTableGroup[];
  getInitialPlans(): InitialPlan[];
}
